import React from 'react';
import {
  FormTwoColumnsGeneric,
  FormTreeColumnsGeneric,
  FormOneColumnGenericInline,
  WarningParagraph,
  TooltipCard,
  TooltipBox,
  CEPContainer,
} from './styles';

import {
  GenericTextInput,
  GenericSelectInput,
  GenericPhoneInput,
  EmailInput,
  EmailInputValid,
  CepInput,
  AddressInput,
  AddressNumberInput,
  AddressComplementInput,
  StateInput,
  CityInput,
  BairroInput,
  TipoPessoaSelect,
} from './FormInputs';
import ConjugeFilhoInput from './ConjugeFilhoInput';
import PessoaSinistradaInput from './PessoaSinistradaInput';
import {
  GENDER_OPTIONS,
  KINSHIP_OPTIONS,
  TIPO_PESSOA,
} from '../../../../constants';
import { cepMask, readProperty } from '../../../../utils';


export const DadosSegurado = ({ tipoPessoa, cnpjSegurado, razaoSocialSegurado, cpfSegurado, nomeSegurado, dthNascimentoSegurado, sexoSegurado, formikBag }) => (
  <>
    <WarningParagraph>1 - Dados do Segurado</WarningParagraph>
    <WarningParagraph>
      O seguro/plano foi contratado por pessoa física ou por pessoa jurídica?
    </WarningParagraph>

    <FormOneColumnGenericInline>
      <TipoPessoaSelect
        controlId="formSinistro.segurado.tipoPessoa"
        name="segurado.tipoPessoa"
        value={tipoPessoa}
        onChange={tipoPessoa}
        options={TIPO_PESSOA}
        formikBag={formikBag}
      />
    </FormOneColumnGenericInline>

    {tipoPessoa === 'PessoaJuridica' && (
      <FormTwoColumnsGeneric>
        <GenericTextInput
          controlId="formSinistro.segurado.cnpjSegurado"
          name="segurado.cnpjSegurado"
          label="Qual o CNPJ da empresa titular? *"
          placeHolder="Digite o CNPJ da empresa titular"
          value={cnpjSegurado}
          typeField="cnpj"
          length="18"
          formikBag={formikBag}
        />
        <GenericTextInput
          controlId="formSinistro.segurado.razaoSocialSegurado"
          name="segurado.razaoSocialSegurado"
          label="Qual a razão social da empresa titular? *"
          placeHolder="Digite a razão social da empresa titular"
          value={razaoSocialSegurado}
          typeField="text"
          length="60"
          formikBag={formikBag}
        />
      </FormTwoColumnsGeneric>
    )}
    <FormTwoColumnsGeneric>
      <GenericTextInput
        controlId="formSinistro.segurado.cpfSegurado"
        name="segurado.cpfSegurado"
        label="Qual o CPF do segurado? *"
        placeHolder="Digite o CPF do segurado"
        value={cpfSegurado}
        typeField="cpf"
        length="14"
        formikBag={formikBag}
      />
      <GenericTextInput
        controlId="formSinistro.segurado.nomeSegurado"
        name="segurado.nomeSegurado"
        label="Qual o nome completo do segurado? *"
        placeHolder="Digite o nome completo do segurado"
        value={nomeSegurado}
        typeField="text"
        length="60"
        formikBag={formikBag}
      />
    </FormTwoColumnsGeneric>
    <FormTwoColumnsGeneric>
      <GenericTextInput
        controlId="formSinistro.segurado.dthNascimentoSegurado"
        name="segurado.dthNascimentoSegurado"
        label="Qual a data de nascimento do segurado? *"
        placeHolder="Digite a data de nascimento do segurado"
        value={dthNascimentoSegurado}
        typeField="date"
        length="10"
        formikBag={formikBag}
      />
      <GenericSelectInput
        controlId="formSinistro.segurado.sexoSegurado"
        name="segurado.sexoSegurado"
        label="Qual o sexo do segurado? *"
        placeHolder="Escolha o sexo do segurado"
        value={sexoSegurado}
        options={GENDER_OPTIONS}
        formikBag={formikBag}
      />
    </FormTwoColumnsGeneric>
  </>
);

export const DadosReclamante = ({ grauParentesco, nomeReclamante,
  telefoneResidencial, telefoneCelular, email,
  emailValid, cep, endereco, cidade, bairro, complemento,
  numero, estado, formikBag, isGrauParentescoPessoaTitular,
  nomeSegurado, ValueReclamanteCpf, CEP_INPUT_NAME, getAddress }) => (
  <>
    <WarningParagraph>
      2 - Dados do Reclamante (pessoa que está abrindo este comunicado de
      sinistro)
    </WarningParagraph>

    <FormTreeColumnsGeneric>
      <GenericSelectInput
        controlId="formSinistro.reclamante.grauParentesco"
        name="reclamante.grauParentesco"
        label="Qual seu grau de parentesco com o segurado? *"
        placeHolder="Selecione o grau de parentesco"
        value={grauParentesco}
        options={KINSHIP_OPTIONS}
        formikBag={formikBag}
      />
    </FormTreeColumnsGeneric>

    <FormTwoColumnsGeneric>
      <GenericTextInput
        controlId="formSinistro.reclamante.nomeReclamante"
        name="reclamante.nomeReclamante"
        label="Qual o nome completo do reclamante? *"
        placeHolder="Digite o nome completo do reclamante"
        value={isGrauParentescoPessoaTitular ? nomeSegurado : nomeReclamante}
        typeField="text"
        length="60"
        disabled={isGrauParentescoPessoaTitular}
        formikBag={formikBag}
      />
      <GenericTextInput
        controlId="formSinistro.reclamante.cpfReclamante"
        name="reclamante.cpfReclamante"
        label="Qual o CPF do reclamante? *"
        placeHolder="Digite o CPF do reclamante"
        value={ValueReclamanteCpf}
        typeField="cpf"
        length="14"
        disabled={isGrauParentescoPessoaTitular}
        formikBag={formikBag}
      />
    </FormTwoColumnsGeneric>

    <FormTreeColumnsGeneric>
      <GenericPhoneInput
        controlId="formSinistro.reclamante.telefoneCelular"
        name="reclamante.telefoneCelular"
        label="Qual seu telefone celular? *"
        placeHolder="Digite o DDD e o seu telefone celular"
        value={telefoneCelular}
        formikBag={formikBag}
      />
      <GenericPhoneInput
        controlId="formSinistro.reclamante.telefoneResidencial"
        name="reclamante.telefoneResidencial"
        label="Qual seu telefone residencial?"
        placeHolder="Digite o DDD e o seu telefone residencial"
        value={telefoneResidencial}
        formikBag={formikBag}
      />
    </FormTreeColumnsGeneric>

    <FormTwoColumnsGeneric>
      <EmailInput email={email} formikBag={formikBag} />
      <EmailInputValid emailValid={emailValid} formikBag={formikBag} />
    </FormTwoColumnsGeneric>

    <CEPContainer>
      <CepInput
        label="CEP *"
        cep={cep}
        onChange={(e) => {
          e.target.value = cepMask(e.target.value);
          formikBag.onChange(e);
        }}
        onBlur={(e) => {
          formikBag.onBlur(e);
          if (!readProperty(formikBag.errors, CEP_INPUT_NAME)) {
            getAddress(cep);
          }
        }}
        formikBag={formikBag}
      />
    </CEPContainer>

    <FormTreeColumnsGeneric>
      <AddressInput
        label="Endereço *"
        endereco={endereco}
        formikBag={formikBag}
      />
      <CityInput
        label="Cidade *"
        cidade={cidade}
        formikBag={formikBag}
      />
      <BairroInput
        label="Bairro *"
        bairro={bairro}
        formikBag={formikBag}
      />
    </FormTreeColumnsGeneric>

    <FormTreeColumnsGeneric>
      <AddressComplementInput
        label="Complemento"
        complemento={complemento}
        formikBag={formikBag}
      />
      <AddressNumberInput
        label="Número *"
        numero={numero}
        formikBag={formikBag}
      />
      <StateInput
        label="Estado *"
        state={estado}
        formikBag={formikBag}
      />
    </FormTreeColumnsGeneric>
  </>
);

export const DadosSinistro = ({ evento, causa, pessoa, nomeConjugeFilho,
  cpfConjugeFilho, dthNascimentoConjugeFilho, dthSinistro, dthAcidente,
  formikBag, isTooltipe, optionsEvento, optionCausa,
  isEventoMorte, isPessoaConjugeOuFilho, labelNome, LabelCPF,
  LabelDataNascimento, selectInputOptionsPessoa,
  isEventoInvalidezAfastamentoMedicoDiariaInternacao,
  isCausaAcidentall, isCausaDoenca, isCausaQuebraOsso, isCausaCuidadoDomiciliar,
  isCausaProcedimentoCirurgico,isCausaNatural }) => (
  <>
    <WarningParagraph>3 - Dados do Sinistro</WarningParagraph>

    <FormTreeColumnsGeneric>
      {!isTooltipe ? (
        <GenericSelectInput
          controlId="formSinistro.dadosSinistro.evento"
          name="dadosSinistro.evento"
          label="Evento Ocorrido *"
          placeHolder="Selecione o evento ocorrido"
          value={evento}
          options={optionsEvento}
          formikBag={formikBag}
        />
      ) : (
        <TooltipCard>
          <TooltipBox>
            Cobertura exclusiva para produto de previdência.
          </TooltipBox>
          <GenericSelectInput
            controlId="formSinistro.dadosSinistro.evento"
            name="dadosSinistro.evento"
            label="Evento *"
            placeHolder="Selecione o evento ocorrido"
            value={evento}
            options={optionsEvento}
            formikBag={formikBag}
          />
        </TooltipCard>
      )}
      <GenericSelectInput
        controlId="formSinistro.dadosSinistro.causa"
        name="dadosSinistro.causa"
        label="Causa *"
        placeHolder="Selecione a causa"
        value={causa}
        options={optionCausa}
        formikBag={formikBag}
      />
      <PessoaSinistradaInput
        isEventoMorte={isEventoMorte}
        pessoa={pessoa}
        selectInputOptionsPessoa={selectInputOptionsPessoa}
        formikBag={formikBag}
      />
    </FormTreeColumnsGeneric>

    <ConjugeFilhoInput
      isEventoMorte={isEventoMorte}
      isPessoaConjugeOuFilho={isPessoaConjugeOuFilho}
      labelNome={labelNome}
      LabelCPF={LabelCPF}
      LabelDataNascimento={LabelDataNascimento}
      nomeConjugeFilho={nomeConjugeFilho}
      cpfConjugeFilho={cpfConjugeFilho}
      dthNascimentoConjugeFilho={dthNascimentoConjugeFilho}
      formikBag={formikBag}
    />

    {isEventoMorte && isCausaAcidentall && (
      <FormTwoColumnsGeneric>
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthSinistro"
          name="dadosSinistro.dthSinistro"
          label="Qual a data do sinistro? *"
          placeHolder="Digite a data do sinistro"
          value={dthSinistro}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthAcidente"
          name="dadosSinistro.dthAcidente"
          label="Qual a data do acidente? *"
          placeHolder="Digite a data do acidente"
          value={dthAcidente}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
      </FormTwoColumnsGeneric>
    )}
    {isEventoMorte && isCausaNatural && (
      <FormTwoColumnsGeneric>
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthSinistro"
          name="dadosSinistro.dthSinistro"
          label="Qual a data do sinistro *"
          placeHolder="Digite a data do sinistro"
          value={dthSinistro}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
      </FormTwoColumnsGeneric>
    )}

    {isEventoInvalidezAfastamentoMedicoDiariaInternacao && (isCausaAcidentall || isCausaQuebraOsso) && (
      <FormTwoColumnsGeneric>
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthSinistro"
          name="dadosSinistro.dthSinistro"
          label="Qual a data do sinistro *"
          placeHolder="Digite a data do sinistro"
          value={dthSinistro}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthAcidente"
          name="dadosSinistro.dthAcidente"
          label="Qual a data do acidente? *"
          placeHolder="Digite a data do acidente"
          value={dthAcidente}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
      </FormTwoColumnsGeneric>
    )}
    {(isCausaCuidadoDomiciliar || isCausaProcedimentoCirurgico) && isEventoInvalidezAfastamentoMedicoDiariaInternacao && isCausaDoenca && (
      <FormTwoColumnsGeneric>
        <GenericTextInput
          controlId="formSinistro.dadosSinistro.dthSinistro"
          name="dadosSinistro.dthSinistro"
          label="Qual a data do sinistro *"
          placeHolder="Digite a data do sinistro"
          value={dthSinistro}
          typeField="date"
          length="10"
          formikBag={formikBag}
        />
      </FormTwoColumnsGeneric>
    )}
  
  </>
);